// Components mounted by the public job pages that load the `job_new` pack:
// the default, WCAG and TLP job templates and the pages JobRenderer renders
// with the `new_job` layout (app/views/jobs/**), plus the TLP builder preview.
//
// Keep this list to what those views mount. It is checked against the views by
// app/javascript/public_rendering/__tests__/registry.test.js.
const jobPageComponents = {
  'WCAG/AboutUs': () => require('../components/WCAG/AboutUs.tsx'),
  'WCAG/ApplicationFlow': () => require('../components/WCAG/ApplicationFlow.tsx'),
  'WCAG/ApplyNow': () => require('../components/WCAG/ApplyNow.tsx'),
  'WCAG/Header': () => require('../components/WCAG/Header.tsx'),
  'WCAG/InfoAlert': () => require('../components/WCAG/InfoAlert.tsx'),
  'WCAG/PageLoader': () => require('../components/WCAG/PageLoader.tsx'),
  'WCAG/ScrollHeader': () => require('../components/WCAG/ScrollHeader.tsx'),
  'WCAG/SourceSelection': () => require('../components/WCAG/SourceSelection.tsx'),
  'NewUI/Public/SaveSuccess': () => require('../components/NewUI/Public/SaveSuccess/index.tsx'),
  'AIStudio/AIInterviewModal/AIInterviewModal': () =>
    require('../components/AIStudio/AIInterviewModal/AIInterviewModal.tsx')
};

export default jobPageComponents;
